import React from 'react'

const BkFlowNavigationStepButton = props =>  {
	const {
		customClasses,
		activeStep,
		buttonContent,
		buttonValue,
		stepEvent,
		stepValue,
	} = props

	let currentClasses = 'bk-flow-navigation__data-col start-xs u-mobile-hide-tablet-flex grid-step'

	if (Number(activeStep) === Number(stepValue) && customClasses) {
		currentClasses = 'bk-flow-navigation__data-col start-xs grid-step active ' + customClasses
	} else if (Number(activeStep) === Number(stepValue)){
		currentClasses = 'bk-flow-navigation__data-col start-xs grid-step active'
	} else if (customClasses) {
		currentClasses = 'bk-flow-navigation__data-col start-xs grid-step ' + customClasses
	} else {
		currentClasses = 'bk-flow-navigation__data-col start-xs grid-step'
	}

	if (stepEvent) {
		currentClasses = currentClasses + ' pointer'
	}

	return  (
		<div
			key={ 'nav-grid-step-' + stepValue }
			className={ currentClasses }
			onClick={ stepEvent ? () => stepEvent(stepValue) : null }
			tabIndex={ customClasses === 'total' ? -1 : 0 }
			role={stepEvent ? 'button' : null}
		>
			<p className="col-sm-12">{ buttonContent }</p>
			<p className="col-sm-12">{ buttonValue }</p>
		</div>
	)
}

export default BkFlowNavigationStepButton


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationStepButton.js